import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const textVariants = cva("font-sans", {
  variants: {
    variant: {
      body: "text-base leading-relaxed",
      caption: "text-sm text-muted-foreground leading-snug",
      label: "text-sm font-medium leading-none",
      overline: "text-xs font-bold tracking-[0.15em] uppercase",
    },
  },
  defaultVariants: {
    variant: "body",
  },
})

type TextElement = HTMLParagraphElement | HTMLSpanElement

interface TextProps
  extends React.HTMLAttributes<TextElement>,
    VariantProps<typeof textVariants> {
  as?: React.ElementType
}

function Text({ variant = "body", as, className, ...props }: TextProps) {
  const Tag = as ?? (variant === "body" ? "p" : "span")
  return (
    <Tag className={cn(textVariants({ variant }), className)} {...props} />
  )
}

export { Text, textVariants }
